import BodyText from 'components/text/BodyText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ActivityHeaderText: FunctionComponent<Props> = props => {
    const { children = props.text, className = '', testId = TEST_ID } = props;

    return (
        <BodyText className={`${className} ${styles.activityHeaderText}`} testId={testId}>
            {children}
        </BodyText>
    );
};

export default ActivityHeaderText;
